import "./createpost.css";
import loginImg from "../assets/images/logo.svg";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Icons
import { MdOutlineNotifications } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";

const CreatePost = () => {
  const navigate = useNavigate();

  const [showSettings, setShowSettings] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  // Platform state
  const [platform, setPlatform] = useState("instagram");

  // Form states
  const [title, setTitle] = useState("");
  const [caption, setCaption] = useState("");
  const [location, setLocation] = useState("");
  const [tags, setTags] = useState("");

  const handleLogout = () => {
    navigate("/login");
  };

  const handleSubmit = () => {
    if (!caption.trim()) {
      alert("Caption is required");
      return;
    }

    alert("Post created successfully!");
    navigate("/");
  };

  return (
    <div className="create-post-page">

      {/* ===== Top Header ===== */}
      <div className="top-header">
        <span className="brand">
          <img src={loginImg} alt="Logo" className="login-image" />
        </span>

        <div className="top-actions">
          <button
            className="icon-btn"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowSettings(false);
            }}
          >
            <MdOutlineNotifications />
          </button>

          <button
            className="icon-btn"
            onClick={() => {
              setShowSettings(!showSettings);
              setShowNotifications(false);
            }}
          >
            <IoSettingsOutline />
          </button>
        </div>

        {showNotifications && (
          <div className="dropdown notification-dropdown">
            <p className="dropdown-title">Notifications</p>
            <ul>
              <li>🔔 New follower joined</li>
              <li>❤️ Someone liked your post</li>
              <li>💬 New comment on your post</li>
            </ul>
          </div>
        )}

        {showSettings && (
          <div className="dropdown settings-dropdown">
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>

      {/* ===== Create Post Card ===== */}
      <div className="create-post">

        {/* Platform Tabs */}
        <div className="platform-tabs">
          <button
            className={platform === "twitter" ? "active" : ""}
            onClick={() => setPlatform("twitter")}
          >
            Twitter
          </button>

          <button
            className={platform === "instagram" ? "active" : ""}
            onClick={() => setPlatform("instagram")}
          >
            Instagram
          </button>

          <button
            className={platform === "tiktok" ? "active" : ""}
            onClick={() => setPlatform("tiktok")}
          >
            TikTok
          </button>

          <button
            className={platform === "youtube" ? "active" : ""}
            onClick={() => setPlatform("youtube")}
          >
            YouTube
          </button>
        </div>

        {/* Form */}
        <div className="post-form">
          <label>Title</label>
          <input
            type="text"
            placeholder="Austria: Panoramic Lake"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <label>Caption</label>
          <textarea
            rows="4"
            placeholder="A canvas painted by nature, framed by the Alps..."
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          />

          <label>Location</label>
          <select
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          >
            <option value="">Select location</option>
            <option>Seebensee, Austria</option>
            <option>Vienna, Austria</option>
          </select>

          <label>Tag</label>
          <input
            type="text"
            placeholder="Add people by name or username"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />

          <label>Schedule Post</label>
          <div className="schedule-row">
            <input type="date" />
            <input type="time" />
          </div>

          <div className="form-actions">
            <button className="draft-btn">Save Draft</button>
            <button className="schedule-btn" onClick={handleSubmit}>
              Schedule
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePost;
